export const IconGrayUsersCabinet: {
  name: 'icon_gray_users_cabinet-4c51968e6a96'
} = {
  name: 'icon_gray_users_cabinet-4c51968e6a96'
}
